module.exports = __webpack_public_path__ + "static/media/Davy.355a3eca.png";